.root {
  position: fixed;
  bottom: 0;
  z-index: var(--z-over-intercom);
  width: 100%;
  padding: 1rem;
  margin: 0 auto;
  color: var(--gray-50);
  background-color: var(--blue-darkdark);
}

.compact {
  transform: translateY(100%);
  transition: transform 0.5s ease;
}

.open {
  transform: translateY(0);
}

.preview {
  cursor: pointer;

  & > * + * {
    margin-top: 1rem;
  }
}

.show {
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 11px;
  font-weight: var(--font-weight-medium);
}

.title {
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
}

.extended {
  z-index: var(--z-over-intercom);
  height: 40vh;
  min-height: 500px;
  background-color: var(--blue-darkdark);
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;

  & > * + * {
    margin-top: 2rem;
  }
}

.actions {
  display: flex;
  justify-content: flex-end;
}

.bigcover {
  width: 8rem;
  margin-right: 0.5rem;
}

.cover {
  width: 4rem;
}

.content {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.play {
  width: 2rem;
  height: 2rem;
  margin-left: auto;
}

.dummy {
  position: relative;
  width: 100%;
  height: 3px;
  overflow: hidden;
  cursor: pointer;
  background: currentColor;
  border-radius: 5px;
}

.bigdummy {
  position: relative;
  width: 100%;
  height: 8px;
  overflow: hidden;
  cursor: pointer;
  background: currentColor;
  border-radius: 5px;
}

.progress {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  content: "";
  background: var(--secondary);
}

.timeline {
  display: flex;
  gap: 0.5rem;
  align-items: center;

  & > * {
    line-height: 1em;
  }
}

.playBig {
  width: 74px;
  height: 74px;
}

.jump {
  width: 64px;
  height: 64px;
  color: var(--white);

  &[aria-disabled="true"] {
    opacity: 0.5;
  }
}

.controls {
  display: flex;
  gap: 2rem;
  align-items: center;
  justify-content: center;
  margin-top: 3rem;
}

.close {
  width: 3rem;
  height: 3rem;
  color: var(--blue-50);
}

.enter {
  opacity: 0;
  transform: translateY(100%);
}

.enterActive {
  opacity: 1;
  transform: translateY(0%);
  transition:
    transform 300ms,
    opacity 150ms;
}

.exit {
  opacity: 1;
  transform: translateY(0);
}

.exitActive {
  opacity: 0;
  transform: translateY(100%);
  transition:
    transform 300ms,
    opacity 500ms;
}

.appear {
  opacity: 0;
  transform: translateY(100%);
}

.appearActive {
  opacity: 1;
  transform: translateY(0);
  transition:
    transform 300ms,
    opacity 150ms;
}
